import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function useGeoCurrency() {
  const [currency, setCurrency] = useState("INR");
  useEffect(() => {
    api.get("/geo/currency").then((r) => setCurrency(r.data.currency)).catch(() => {});
  }, []);
  return currency;
}

export const priceLabel = (inr, usd, currency) =>
  currency === "USD" && Number(usd) > 0
    ? `$${Number(usd).toLocaleString()}`
    : `₹${Number(inr || 0).toLocaleString()}`;
